export enum RevisionCommentPlacement {
  AfterDocument = "after-document",
  BeforeDocument = "before-document",
}

export const RevisionCommentPlacementOptions = [
  {
    label: "Above student's paper",
    value: RevisionCommentPlacement.BeforeDocument,
  },
  {
    label: "Below student's paper",
    value: RevisionCommentPlacement.AfterDocument,
  },
];
